import { render, staticRenderFns } from "./TemplateBody.vue?vue&type=template&id=c881ccd2&scoped=true&"
import script from "./TemplateBody.vue?vue&type=script&lang=js&"
export * from "./TemplateBody.vue?vue&type=script&lang=js&"
import style0 from "./TemplateBody.vue?vue&type=style&index=0&id=c881ccd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c881ccd2",
  null
  
)

export default component.exports